var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import { OpType } from '../types';

var ModelMerger = function () {
  function ModelMerger(outbox, ownSymbol) {
    this.outbox = outbox;
    this.ownSymbol = ownSymbol;
  }

  ModelMerger.prototype.merge = function (storage, model) {
    return __awaiter(this, void 0, void 0, function () {
      var result, mutationsForModel, isDelete;

      var _a, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4
            /*yield*/
            , this.outbox.getForModel(storage, model)];

          case 1:
            mutationsForModel = _c.sent();
            isDelete = model._deleted;
            if (!(mutationsForModel.length === 0)) return [3
            /*break*/
            , 5];
            if (!isDelete) return [3
            /*break*/
            , 3];
            result = OpType.DELETE;
            return [4
            /*yield*/
            , storage.delete(model, undefined, this.ownSymbol)];

          case 2:
            _c.sent();

            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , storage.save(model, undefined, this.ownSymbol)];

          case 4:
            _a = __read.apply(void 0, [_c.sent(), 1]), _b = __read(_a[0], 2), result = _b[1];
            _c.label = 5;

          case 5:
            return [2
            /*return*/
            , result];
        }
      });
    });
  };

  ModelMerger.prototype.mergePage = function (storage, modelConstructor, items) {
    return __awaiter(this, void 0, void 0, function () {
      var itemsMap, items_1, items_1_1, item, page;

      var e_1, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            itemsMap = new Map();

            try {
              for (items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                item = items_1_1.value; // merge items by model id. Latest record for a given id remains.

                itemsMap.set(item.id, item);
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
              } finally {
                if (e_1) throw e_1.error;
              }
            }

            page = __spread(itemsMap.values());
            return [4
            /*yield*/
            , storage.batchSave(modelConstructor, page, this.ownSymbol)];

          case 1:
            return [2
            /*return*/
            , _b.sent()];
        }
      });
    });
  };

  return ModelMerger;
}();

export { ModelMerger };